"use strict";
import ViewBase from "../view-base.view";
import UserBadgeComponent from "../../components/common/user-badge.component";
import { staticUrls } from "../../config/constants";
import 'CssFolder/voc/voc-list-item.scss';

export default function VocsListItemView() {
  ViewBase.call(this);
  let voc;
  let onClick = (vocId) => { };
  let checkedChanged=()=>{};
  let getFirstThumbnail = (voc) => {
    let photoString = voc?.firstPhotoString;

    if (photoString && photoString.length > 0) {
      return photoString;
    }

    return staticUrls.fileImage;
  }

  let getFileCount = (voc) => {
    let count = voc?.attachmentNumber ? voc.attachmentNumber : 0;
    return count;
  }

  return {
    oninit: (vnode) => {
      voc = vnode.attrs.voc;
      if (vnode.attrs.onClick) {
        onClick = vnode.attrs.onClick;
      }
      if(vnode.attrs.checkedChanged){
        checkedChanged=vnode.attrs.checkedChanged;
      }
    },
    view: (vnode) => {
      return m('.voc-item.card',
        m('.card-body', 
        // {
        //   onclick: () => {
        //     onClick(voc.vocId);
        //   }
        // },
          m('.voc-item-sections',
          
               m('input.form-check-input.flex-shrink-0[type=checkbox]', {
                checked:vnode.attrs.voc.checked, //vnode.attrs.isSelected,
                onchange: (e) => {
                  vnode.attrs.voc.checked=e.target.checked;
                  checkedChanged();
                  // onCheckboxChange(survey.surveyIdString, Boolean(e.target.checked))
                }
              }),
            m('.voc-item-user-info',
              m(UserBadgeComponent, {
                onclick: () => {
                  onClick(voc.vocId);
                },
                image: voc.requestorPhotoString,
                imageSize: '48px',
                flexDirection: 'column',
              }, [
                m('.user-name', { title: voc.requestorName },  voc.requestorName),
              ]),
            ),
            // Main Section
            m('.voc-item-main',{
              onclick: () => {
                onClick(voc.vocId);
              }
            },
              m('.voc-item-main__title', { title: voc.title }, voc.isUrgentYN === 'Y' && m('span.text-danger.fw-bold', '! '), `[#${voc.vocIdString}] ${voc.title}`),
              m('.voc-item-main__datetime', { title: voc.loggedDateTime }, `${voc.loggedDateTime} - `, m('span.fw-bold', voc.numberOfDays + ' ' + this.getText("LT00000365", "day(s)"))),
              m('.voc-item-main__description', { title: voc.description }, voc.description),
              m('.voc-item-main__site', { title: voc.siteName }, m('span.fw-bold', `[${voc.siteId}]`), ` ${voc.siteName}`),
            ),
            // Secondary Section
            m('.voc-item-secondary',
            {
              onclick: () => {
                onClick(voc.vocId);
              }
            },
              m('.voc-item-secondary__info', { title: voc.gscmDiv }, m('.voc-item-secondary__info-title', this.getText("LT00000241", "GSCM Division") + ': '), voc.gscmDiv),
              m('.voc-item-secondary__info', { title: voc.category }, m('.voc-item-secondary__info-title', this.getText("LT00000366", "Category") + ': '), voc.category),
              m('.voc-item-secondary__info', { title: voc.subCategory }, m('.voc-item-secondary__info-title', this.getText("LT00000367", "Sub-category") + ': '), voc.subCategory),
              m('.voc-item-secondary__info', { title: voc.item }, m('.voc-item-secondary__info-title', this.getText("LT00000368", "Item") + ': '), voc.item),
            ),
            // Image Section
            m('.voc-item-image',
            {
              onclick: () => {
                onClick(voc.vocId);
              }
            },
              m('.voc-item-image__img-wrapper',
                m('img', { src: getFirstThumbnail(voc) }),
                m('.voc-item-image__file-count', getFileCount(voc)),
              ),
            )
          ),
        ),
        voc.newMessageFlag === 'Y' &&
        m('span.new-alerts')
      )
    }
  }
}
